import { Icon } from "@phosphor-icons/react";
import clsx from "clsx";
import { NavLink } from "react-router-dom";

export type SideNavigationMenuItemConfig = {
    icon: Icon;
    label: string;
    path: string;
};

const SideNavigationMenuItem = ({
    icon: SideNavItemIcon,
    label,
    path,
}: SideNavigationMenuItemConfig) => {
    return (
        <li className="flex-1 sm:flex-none">
            <NavLink
                to={path}
                className={({ isActive }) =>
                    clsx(
                        "h-14 w-full rounded-xl flex items-center justify-center hover:bg-soft-green-80 transition-colors",
                        isActive && "bg-surface-light-2"
                    )
                }
            >
                <SideNavItemIcon weight="light" size={32} />
                <span className="sr-only">{label}</span>
            </NavLink>
        </li>
    );
};

export default SideNavigationMenuItem;
